import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { BCMCLPUser, TeamCodes } from '../../../models/clpuser.model';
import { CMClub, CMClubResponse, CMSite, CMSiteListResponse } from '../../../models/cm-club-service.model';
import { SimpleResponse, UserDD } from '../../../models/generic-response.model';
import { MemInsuranceDeductible, MemInsuranceDeductibleListRequest, MemInsuranceDeductibleResponse, REFMem_GetAllResponse, REF_MemProtectionPlan, REF_MemProtectionStatus } from '../../../models/membership.model';
import { CMClubService } from '../../../services/cm-club.service';
import { MembershipService } from '../../../services/membership.service';
import { GlobalService } from '../../../services/shared/global.service';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { TeamOfficeService } from '../../../services/team-office.service';
import { UserService } from '../../../services/user.service';

@Component({
    selector: 'app-mem-insurance-deductible-list',
    templateUrl: './mem-insurance-deductible-list.component.html',
    styleUrls: ['./mem-insurance-deductible-list.component.css']
})
/** mem-insurance-deductible-list component*/
export class MemInsuranceDeductibleListComponent {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    dataSource: MatTableDataSource<MemInsuranceDeductible>;
    columns = [{ field: 'contactName', title: 'Name', width: '20' },
    { field: 'protectionPlan', title: 'Protection Plan', width: '20' },
    { field: 'protectionStartDate', title: 'Protection Start Date', width: '80' },
    { field: 'protectionDeductibleAmount', title: 'Protection Deductible Amount', width: '150' },
    { field: 'lostEquipmentCreditTotal', title: 'Lost Equipment CreditTotal', width: '40' },
    { field: 'protectionEndDate', title: 'Protection End Date', width: '40' },
    { field: 'protectionStatus', title: 'Protection Status', width: '40' }];
    encryptedUser: string = ''
    insuranceDeductibleForm: FormGroup;
    user: BCMCLPUser;
    teamSub: Subscription;
    curTeam: TeamCodes = <TeamCodes>{};
    showSpinner: boolean;
    clubConfig: CMClub;
    sites: CMSite[];
    selectedSiteIDs = [];
    deductibles: MemInsuranceDeductible[];
    ref_MemProtectionPlan_List: REF_MemProtectionPlan[];
    ref_MemProtectionStatus_List: REF_MemProtectionStatus[];
    deductiblesListDisplayColumns: string[];
    clpUsersDD: UserDD[];
    memContactListDisplayColumns: string[];
    createDateFilters = [
        {
            "value": 1,
            "name": "This Month"
        },
        {
            "value": 2,
            "name": "Last Month"
        },
        {
            "value": 3,
            "name": "Custom"
        }
    ]
    customFilter: boolean = false;
    customDateStr: string = '';
    selectedCtDtFilterName: string;
    selectedCtDtFilter: number = 1;
    currentRange = new FormGroup({
        start: new FormControl<Date | null>(null),
        end: new FormControl<Date | null>(null),
    });
    selectedCustomdtStart: string;
    selectedCustomdtEnd: string;
    clpCompanyId: number;
    selectedUserID: number = 0;
    users: number[];
    selectedCMSiteID: number = 0;
    sitesIds: number[];
    protectionPlanID: number = 0;
    protectionStatusID: number = 0;
    private destroy$ = new Subject<void>();
    /** mem-insurance-deductible-list ctor */
    constructor(private localService: LocalService,
        private membershipService: MembershipService,
        public _localService: LocalService,
        private _globalService: GlobalService,
        private _router: Router,
        private _utilityService: UtilityService,
        private _teamOfficeService: TeamOfficeService,
        private userService: UserService,
        private fb: FormBuilder,
        private clubService: CMClubService,
        private datePipe: DatePipe
    ) {
        this.localService.setShowMenu(true);
        this.localService.setIsContract(false);
        this.localService.setIsMembership(true);
        this.localService.updateTeamDD(true);
        this.localService.setRouteName("mem-insurance-list");
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }

    ngOnInit() {
        /* this.insuranceDeductibleForm = this.prepareInsuranceDeductibleForm()*/

    }

    //prepareInsuranceDeductibleForm() {
    //    return this.fb.group({

    //    })
    //}

    ngAfterViewInit() {
        this.encryptedUser = localStorage.getItem("token");
        if (this.encryptedUser) {
            this.authenticateR().then(() => {
                if (this.user) {
                    this.loadData();
                }
                else {
                    this._router.navigate(['/unauthorized']);
                }
            });
        }
        else {
            this._router.navigate(['/unauthorized']);
        }
    }

    private async authenticateR() {
        await this._localService.authenticateUser(this.encryptedUser)
            .then(async (result: BCMCLPUser) => {
                if (result) {
                    this.user = UtilityService.clone(result);
                    if (result?.strToken && result?.strToken != '') {
                        this.encryptedUser = result?.strToken;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }


    async loadData() {
        this.teamSub = this._teamOfficeService.curTeam.pipe(takeUntil(this.destroy$)).subscribe(async (data: any) => {
            if (data != 0 && data != null) {
                this.curTeam = data
                if (this.curTeam?.teamCode > 0) {
                    await this.CMClub_Get();
                    await this.siteSearch();
                    this.ref_MemProtectionPlan_List = this.localService.refMem_GetAllResponse.ref_MemProtectionPlan_List;
                    this.ref_MemProtectionStatus_List = this.localService.refMem_GetAllResponse.ref_MemProtectionStatus_List;
                    this.cLPUserGetListByTeamCode(this.user?.cLPCompanyID, this.curTeam?.teamCode);
                    this.memInsuranceDeductible_GetList();
                }
            }
            else {
                this.curTeam = JSON.parse(localStorage.getItem("curTeam") || "{}")
                if (this.curTeam?.teamCode > 0) {
                    await this.CMClub_Get();
                    await this.siteSearch();
                    this.ref_MemProtectionPlan_List = this.localService.refMem_GetAllResponse.ref_MemProtectionPlan_List;
                    this.ref_MemProtectionStatus_List = this.localService.refMem_GetAllResponse.ref_MemProtectionStatus_List;
                    this.cLPUserGetListByTeamCode(this.user?.cLPCompanyID, this.curTeam?.teamCode);
                    this.memInsuranceDeductible_GetList();
                }
            }
        })
    }


    async CMClub_Get() {
        if (this.curTeam?.teamCode > 0) {
            this.showSpinner = true
            await this.clubService.CMClub_Get(this.encryptedUser, this.user?.cLPCompanyID, this.curTeam?.teamCode).
                then(async (result: CMClubResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.clubConfig = response?.clubConfig
                    }
                    this.showSpinner = false
                })
                .catch((err: HttpErrorResponse) => {
                    this.showSpinner = false
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async siteSearch() {
        if (this.clubConfig?.clubId > 0) {
            await this.clubService.siteSearch(this.encryptedUser, 0, this.clubConfig?.clubId, 0, 0).
                then(async (result: CMSiteListResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.sites = response?.sites;
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async memInsuranceDeductible_GetList() {
        let memInsuranceDeductibleListRequest: MemInsuranceDeductibleListRequest = <MemInsuranceDeductibleListRequest>{};
        memInsuranceDeductibleListRequest.clubId = this.clubConfig?.clubId;
        memInsuranceDeductibleListRequest.dateType = 1;
        memInsuranceDeductibleListRequest.protectionPlanID = +this.protectionPlanID;
        memInsuranceDeductibleListRequest.protectionStatusID = +this.protectionStatusID;
        memInsuranceDeductibleListRequest.strdtEnd = this.selectedCustomdtEnd;
        memInsuranceDeductibleListRequest.strdtStart = this.selectedCustomdtStart;
        memInsuranceDeductibleListRequest.timeFrame = this.selectedCtDtFilter;
        memInsuranceDeductibleListRequest.users = this.users;
        memInsuranceDeductibleListRequest.sites = this.sitesIds;
        await this.membershipService.memInsuranceDeductible_GetList(this.encryptedUser, memInsuranceDeductibleListRequest, this.user.cLPUserID)
            .then(async (result: MemInsuranceDeductibleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.deductibles = response?.deductibles;
                    this.setGrid(this.deductibles);

                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("mem-insurance.memInsuranceDeductible_GetList", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    setGrid(list) {
        this.deductiblesListDisplayColumns = this.columns.map(c => c.field);
        this.dataSource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.dataSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = 50;
            }
            if (this.sort) {
                this.dataSource.sort = this.sort;
            }
        }, 500)
    }

    async memPolicyViolation_Delete(insuranceDeductibleID) {
        await this.membershipService.memInsuranceDeductible_Delete(this.encryptedUser, insuranceDeductibleID)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async memPolicyViolation_Get(insuranceDeductibleID) {
        await this.membershipService.memInsuranceDeductible_Get(this.encryptedUser, insuranceDeductibleID,0)
            .then(async (result: MemInsuranceDeductible) => {
                if (result) {
                    let response = UtilityService.clone(result);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    getProtectionDDName(protectionPlanID) {
        let statusName: string = '';
        statusName = this.ref_MemProtectionPlan_List.filter(x => x.statusID == protectionPlanID)[0].status;
        if (statusName != "") {
            return statusName
        } else {
            return '';
        }
    }

    getStatusDDName(statusId) {
        let statusName: string = '';
        statusName = this.ref_MemProtectionStatus_List.filter(x => x.statusID == statusId)[0].status;
        if (statusName != "") {
            return statusName
        } else {
            return '';
        }
    }

    formatDate(dateString) {
        if (dateString != '') {
            const date = new Date(dateString);
            //const formattedDate = `${date.getUTCMonth() + 1}/${date.getUTCDate()}/${date.getUTCFullYear()}`;
            const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
            return formattedDate;
        }
        else return '';
    }

    addProtectionPlan() {
        this._router.navigate(['/mem-insurance']);
    }

       async cLPUserGetListByTeamCode(clpCompanyId, teamCode) {
        await this.userService.cLPUserGetListByTeamCode(this.encryptedUser, clpCompanyId, teamCode ? teamCode : this.user?.cLPUserID).
            then(async (result: UserDD[]) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.clpUsersDD = response
                    this.clpUsersDD.unshift({
                        value: 0,
                        text: "--ALL--"
                    })
                }

            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                    'clpCompanyId: ' + this.clpCompanyId
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async onChangeUserDD() {
        if (this.selectedUserID > 0) {
            this.users = [];
            this.users.push(+this.selectedUserID);
            await this.memInsuranceDeductible_GetList();
        }
        else {
            this.users = [];
            await this.memInsuranceDeductible_GetList();
        }
    }

    async onChangeCMSite() {
        if (this.selectedCMSiteID > 0) {
            this.sitesIds = [];
            this.sitesIds.push(+this.selectedCMSiteID);
            await this.memInsuranceDeductible_GetList();
        }
        else {
            this.sitesIds = [];
            await this.memInsuranceDeductible_GetList();
        }
    }

    async onChangeStatus() {
        await this.memInsuranceDeductible_GetList();
    }

    async createDtFilterChange() {
        let value = this.selectedCtDtFilter;

        if (value != 3) {
            this.selectedCtDtFilter = +value;
            await this.memInsuranceDeductible_GetList();
        }
        else {
            this.customDateStr = ''
            this.customFilter = true;
        }
    }

    revertCustomFinalizeddtFilter() {
        this.customFilter = false;
        this.selectedCtDtFilter = 1;
        this.selectedCtDtFilterName = "This Month";
        this.currentRange = new FormGroup({
            start: new FormControl<Date | null>(null),
            end: new FormControl<Date | null>(null),
        });
        this.memInsuranceDeductible_GetList();
    }


    dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
        var startDt = dateRangeStart.value;
        var endDt = dateRangeEnd.value;
        if (startDt) {
            let customdtStart = this.datePipe.transform(startDt, 'MMddyyyy');
            this.selectedCustomdtStart = customdtStart;

        }
        if (endDt) {
            let customdtEnd = this.datePipe.transform(endDt, 'MMddyyyy');
            this.selectedCustomdtEnd = customdtEnd;
            //this.selectedCtDtFilter = 3;
            this.selectedCtDtFilterName = "Custom"
            if (this.selectedCustomdtStart && this.selectedCustomdtEnd != null) {
                this.memInsuranceDeductible_GetList();
            }
        }
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim().toLowerCase();
        if (this.dataSource) {
            this.dataSource.filter = filterValue;
        }
    }

    onChangeProtectionPlan() {
        this.memInsuranceDeductible_GetList();
    }

    onChangeProtectionStatus() {
        this.memInsuranceDeductible_GetList();
    }


    selectRow(row: any): void {
        if (!row?.insuranceDeductibleID) return;
        const url = `/mem-insurance?insuranceDeductibleID=${row.insuranceDeductibleID}`;
        window.open(url, '_blank');
    }
    navToMemContact(contactID) {
        let url = 'mem-contact/' + contactID;
        window.open(url, '_blank');
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

}
